/**
 * Inventory Search and Sort Functionality
 * Filters products on the collection page without page reload
 */
(function() {
  // Initialize the functionality when the DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize inventory search
    initInventorySearch();

    // Initialize custom sort dropdown if on collection page
    if (document.querySelector('.collection-header-row')) {
      initCustomSortDropdown();
    }

    // Check if we're on the search page and update the page title
    if (window.location.pathname.includes('/search')) {
      // Update page title with search query
      const searchQuery = new URLSearchParams(window.location.search).get('q');
      if (searchQuery) {
        document.title = `Search results for "${searchQuery}" | ${document.title.split('|')[1] || 'JDM Drive'}`;
      }
    }
  });

  function initInventorySearch() {
    // Only initialize on search page, not on collection page
    if (window.location.pathname.includes('/collections/')) {
      return; // Skip initialization on collection pages
    }

    const searchInput = document.getElementById('inventorySearchInput');
    const searchButton = document.getElementById('inventorySearchButton');

    if (!searchInput || !searchButton) return;

    // Add event listeners
    searchInput.addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        performServerSearch();
      }
    });

    searchButton.addEventListener('click', function(event) {
      event.preventDefault();
      performServerSearch();
    });

    // Check for URL parameters and set initial search value
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('q');
    if (searchParam) {
      searchInput.value = searchParam;
    }
  }

  function performServerSearch() {
    const searchInput = document.getElementById('inventorySearchInput');
    const searchTerm = searchInput.value.trim();

    if (searchTerm === '') return;

    // Show loading indicator
    document.body.classList.add('loading');

    // Build the Shopify search URL with optimal parameters
    let searchUrl = `/search?q=${encodeURIComponent(searchTerm)}&type=product&options[prefix]=last&options[unavailable_products]=show`;

    console.log('Redirecting to search URL:', searchUrl);

    // Redirect to the search page
    window.location.href = searchUrl;
  }

  // Custom Sort Dropdown Functionality is handled in collection-header-row.js

  // Custom Sort Dropdown Functionality
  function initCustomSortDropdown() {
    const sortButton = document.getElementById('sortDropdownButton');
    const sortDropdown = document.getElementById('sortDropdownMenu');
    const sortOptions = document.querySelectorAll('.sort-option');
    const sortSelect = document.getElementById('SortBy');
    const currentSortText = document.querySelector('.current-sort-option');

    // Debug info
    console.log('Sort button:', sortButton);
    console.log('Sort dropdown:', sortDropdown);
    console.log('Sort options:', sortOptions.length);
    console.log('Sort select:', sortSelect);

    if (!sortButton || !sortDropdown || !sortOptions.length || !sortSelect) {
      console.log('Missing elements for sort dropdown');
      return;
    }

    // Set initial sort text based on selected option
    updateCurrentSortText();

    // Toggle dropdown on button click
    sortButton.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent event bubbling
      sortDropdown.classList.toggle('active');

      // Force display block to ensure visibility
      if (sortDropdown.classList.contains('active')) {
        sortDropdown.style.display = 'block';
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.custom-sort-dropdown')) {
        sortDropdown.classList.remove('active');
        sortDropdown.style.display = 'none';
      }
    });

    // Handle sort option selection
    sortOptions.forEach(function(option) {
      // Add click handler
      option.addEventListener('click', handleSortOptionClick);

      // Also add click handlers to the spans inside the option
      const spans = option.querySelectorAll('span');
      spans.forEach(function(span) {
        span.addEventListener('click', function(event) {
          event.stopPropagation();
          handleSortOptionClick.call(option, event);
        });
      });
    });

    function handleSortOptionClick(event) {
      event.stopPropagation();
      console.log('Sort option clicked:', this);

      const value = this.getAttribute('data-value');
      console.log('Sort value:', value);

      // Update the hidden select element
      if (sortSelect) {
        sortSelect.value = value;

        // Trigger change event to apply sorting
        const changeEvent = new Event('change', { bubbles: true });
        sortSelect.dispatchEvent(changeEvent);
      }

      // Update active state
      sortOptions.forEach(function(opt) {
        opt.classList.remove('active');
        const checkmark = opt.querySelector('.checkmark');
        if (checkmark) {
          checkmark.textContent = '';
        }
      });

      this.classList.add('active');
      const checkmark = this.querySelector('.checkmark');
      if (checkmark) {
        checkmark.textContent = '✓';
      }

      // Update current sort text
      updateCurrentSortText();

      // Close dropdown
      sortDropdown.classList.remove('active');
      sortDropdown.style.display = 'none';
    }

    function updateCurrentSortText() {
      const activeOption = sortDropdown.querySelector('.sort-option.active');
      if (activeOption) {
        const optionText = activeOption.querySelector('span:last-child').textContent;
        currentSortText.textContent = optionText;
      } else if (sortSelect && sortSelect.selectedIndex >= 0) {
        // Fallback to select option text
        const selectedOption = sortSelect.options[sortSelect.selectedIndex];
        if (selectedOption) {
          currentSortText.textContent = selectedOption.textContent;
        }
      }

      // Force a redraw to ensure text is visible
      setTimeout(() => {
        currentSortText.style.display = 'none';
        // Force a reflow
        void currentSortText.offsetHeight;
        currentSortText.style.display = 'inline-block';
      }, 0);
    }
  }
})();
